import SetPassword from './SetPassword'

export default SetPassword('Aktivace - nastavení hesla')



// WEBPACK FOOTER //
// ./src/screens/AccountActivate.tsx